import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Session persists so PIN can unlock without re-entering full credentials.
// The PIN screen is the security gate — session stays alive behind it.
export const supabase = createClient(supabaseUrl, supabaseAnonKey)
